import React from 'react';
import greenDot from '../../../assets/icons/green-circle.svg';
import yellowDot from '../../../assets/icons/yellow-circle.svg';
import redDot from '../../../assets/icons/red-circle.svg';
import warning from '../../../assets/icons/warning.svg';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  percentage: string;
  processing?: boolean;
  withManual: boolean;
}

const MatchButton = ({ percentage, withManual, processing }: Props) => {
  const checkColor = (percentage: number) => {
    if (percentage >= 75) return greenDot;
    if (percentage >= 50) return yellowDot;
    if (percentage >= 0) return redDot;
  };

  const { t } = useTranslation();

  return (
    <div
      style={{ width: withManual ? '41px' : '' }}
      className='d-flex justify-content-center'
    >
      {processing ? (
        <Spinner
          animation='border'
          variant='info'
          style={{ width: '1.5rem', height: '1.5rem' }}
        />
      ) : percentage == "" ? (
        [<img src={warning} alt={t('messages.unexpectedError')} style={{ width: '24px', height: '24px' }} />]
      ) : (
        <img
          src={checkColor(+percentage * 10)}
          alt='match'
          style={{ width: '16px' }}
        />
      )}
    </div>
  );
};

export default MatchButton;
